import React, { useState, useRef, useEffect } from "react";
import { Link } from "gatsby";
import { Row, Col, Container, Button } from "react-bootstrap";
import _ from "lodash"
import parse from "html-react-parser"
import GenerateLink from "../../../common/site/generate-link"


const AdvertsOne = (props) => {

    var adverts = (props.adverts)

    var help = adverts[props?.adkey]

    // console.log("%%%%%%%%%%%%%---------", props)

    var bg_img = `#005670`
    if(help.Background_Image) {
        bg_img = `url("${help.Background_Image.url}")`
    }

    return (
        <section class="book-valuation components--Home--BookValuation--BookValuation" style={{background:bg_img}}>
            <div class="container">
                <div class="main-row row">
                    <div class="col-lg-12">
                        <div class={`register-interest-form-block ${help.CTA_1_Link && help.CTA_2_Link ? 'no-flex' : 'flex-div'}`}>
                            <div class="valuation-block">
                                {parse(help.Content)}
                            </div>
                            <div class="btn-row">
                                {help.CTA_1_Label &&
                                <GenerateLink  class="btn btn-secondary" link={help.CTA_1_Link}>{help.CTA_1_Label}<i class="icon-arrow"></i></GenerateLink>
                                }
                                {help.CTA_2_Label &&
                                <GenerateLink  class="btn btn-secondary cta-2" link={help.CTA_2_Link}>{help.CTA_2_Label}<i class="icon-arrow"></i></GenerateLink>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default React.memo(AdvertsOne)